import { useState } from 'react';

export default function Login({ onLogin }) {
  const [pw, setPw] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      const ok = onLogin(pw);
      if (!ok) {
        setError('Incorrect password');
        setPw('');
      }
      setLoading(false);
    }, 400);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#0e1015', padding: 24
    }}>
      <div style={{
        width: '100%', maxWidth: 360,
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 20, padding: 32
      }}>
        <div style={{ marginBottom: 28, textAlign: 'center' }}>
          <div style={{
            width: 44, height: 44, borderRadius: 12,
            background: 'white', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px'
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0e1015" strokeWidth="2.5">
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
              <rect x="9" y="3" width="6" height="4" rx="1"/>
            </svg>
          </div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: 'white', marginBottom: 4 }}>Purchase App</h1>
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)' }}>Admin access only</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '0.08em', display: 'block', marginBottom: 8 }}>
              Password
            </label>
            <input
              type="password"
              autoFocus
              value={pw}
              onChange={e => { setPw(e.target.value); setError(''); }}
              placeholder="Enter password"
              style={{
                width: '100%', background: 'rgba(255,255,255,0.06)',
                border: `1px solid ${error ? 'rgba(248,113,113,0.5)' : 'rgba(255,255,255,0.1)'}`,
                borderRadius: 12, padding: '12px 16px',
                fontSize: 14, color: 'white', outline: 'none',
                fontFamily: 'inherit'
              }}
            />
            {error && <p style={{ fontSize: 12, color: '#f87171', marginTop: 6 }}>{error}</p>}
          </div>

          <button
            type="submit"
            disabled={!pw || loading}
            style={{
              width: '100%', padding: '13px',
              background: pw && !loading ? 'white' : 'rgba(255,255,255,0.15)',
              color: pw && !loading ? '#0e1015' : 'rgba(255,255,255,0.3)',
              border: 'none', borderRadius: 12,
              fontSize: 14, fontWeight: 700,
              cursor: pw && !loading ? 'pointer' : 'not-allowed',
              fontFamily: 'inherit', transition: 'all 0.15s'
            }}
          >
            {loading ? 'Checking...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
